import { Service } from '../mainService'

const solicitacoesAssinaturaService = {
    buscarAssinaturas,
    baixarArquivoAssinatura,
    carregarHistoricoAssinaturas,
    assinarEnviarDocumento,
    iniciarAssinaturaToken,
    finalizarAssinaturaToken
}

async function buscarAssinaturas() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_MESSAGES_API + "/solicitacoesassinatura/buscarassinaturas");
        return response;
    } catch (e) {
        return e.response;
    }
}

async function carregarHistoricoAssinaturas() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_MESSAGES_API + "/solicitacoesassinatura/historicoassinaturas");
        return response;
    } catch (e) {
        return e.response;
    }
}

async function baixarArquivoAssinatura(codArquivo) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_MESSAGES_API + "/solicitacoesassinatura/baixararquivoassinatura/"+codArquivo, {
            responseType: "blob",
        });
        return response;
    } catch (e) {
        return e.response;
    }
}

async function assinarEnviarDocumento(data) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_MESSAGES_API + "/solicitacoesassinatura/assinarEnviarDocumento", data,
            /*{
                headers: {
                "content-type": "multipart/form-data",
                },
            }*/
        );
        return response;
    } catch (e) {
        return e.response;
    }
}
async function iniciarAssinaturaToken(data) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_MESSAGES_API + "/solicitacoesassinatura/iniciarAssinaturaToken", data);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function finalizarAssinaturaToken(data) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_MESSAGES_API + "/solicitacoesassinatura/finalizarAssinaturaToken", data, {
            headers: {
                "Content-Type": "application/json",
            }
        });

        return response;
    } catch (e) {
        return e.response;
    }
}

export default solicitacoesAssinaturaService